import * as React from "react";
const SvgComment = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <path
      fill="#505050"
      fillRule="evenodd"
      d="M6.417 3.885c-1.913 0-3.464 1.44-3.464 3.217v3.079c0 1.776 1.551 3.217 3.464 3.217h1.245c.16 0 .308.074.397.197L9 14.906l.941-1.311a.49.49 0 0 1 .397-.197h1.245c1.913 0 3.464-1.44 3.464-3.217V7.102c0-1.776-1.551-3.217-3.464-3.217zM2 7.102C2 4.837 3.978 3 6.417 3h5.166C14.023 3 16 4.837 16 7.102v3.079c0 2.265-1.978 4.102-4.417 4.102h-.99l-1.032 1.438a.703.703 0 0 1-1.122 0l-1.032-1.438h-.99C3.977 14.283 2 12.446 2 10.181z"
      clipRule="evenodd"
    />
    <path
      fill="#505050"
      d="M4.986 8.662c0-.412.36-.746.803-.746s.802.334.802.746c0 .411-.359.745-.802.745s-.803-.334-.803-.745M8.197 8.662c0-.412.36-.746.803-.746s.803.334.803.746c0 .411-.36.745-.803.745s-.803-.334-.803-.745M11.409 8.662c0-.412.36-.746.802-.746.444 0 .803.334.803.746 0 .411-.36.745-.803.745s-.802-.334-.802-.745"
    />
  </svg>
);
export default SvgComment;
